'use client'

import DisablePrefetchLink from '@component/disablePrefetchLink'
import IconWebsite from '@icon/website.svg'

export default function OfficeWebsiteButton({
  data
}) {
  return data.website && (
    <DisablePrefetchLink href={data.website} className='button-primary-out w-full px-30 flex items-center' target='_blank' rel='noreferrer'>
      <IconWebsite width={16} height={16} fill='var(--color-theme)'></IconWebsite>
      <span className='flex-1 text-center'>Visit agency site</span>
    </DisablePrefetchLink>
  )
}